import { Attachment } from "./Attachment";
import { CategoryEntity } from "./Category";

export interface Question {
  _id?: string;
  title?: string;
  difficulty?: string;
  category?: CategoryEntity;
  attachment?: Attachment;
  type?: QuestionType;
  createdAt?: Date;
}

export interface GivenAnswer {
  isCorrect: boolean;
  byPlayer: string;
}

export interface Answer {
  _id?: string;
  question?: string;
  title?: string;
  attachment?: Attachment;
}

export enum Difficulty {
  EASY = "Easy",
  MEDIUM = "Medium",
  HARD = "Hard",
}

export enum QuestionType {
  NORMAL = "Normal",
  TYPE_1 = "Video is shown first and only when the video ends then the timer starts. Then the timer starts and the video can be replayed just like the first type",
  TYPE_2 = "Video starts first and when it does it cannot be paused until it ends, once it ends the question is shown and they can not replay the video or anything like that",
  TYPE_3 = "Exactly like the previous type but the video is shown twice instead of once",
}

export function difficultyStringToDifficulty(d: string): Difficulty {
  switch (d) {
    case "Easy":
      return Difficulty.EASY;
    case "Medium":
      return Difficulty.MEDIUM;
    case "Hard":
      return Difficulty.HARD;
    default:
      return Difficulty.EASY;
  }
}

export interface DifficultyInfo {
  text: string;
  color: string;
  point: number;
}

export interface GetRandomQuestionRequestModel {
  categoryId: string;
  difficulty: string;
}
